import { createFileRoute, Outlet } from '@tanstack/react-router'
import { MaximoWorkOrders } from 'pages/maximoWorkOrders/MaximoWorkOrders'

export const Route = createFileRoute('/maximo/{-$siteID}')({
  component: MaximoRouteComponent,
  staticData: {
    title: 'Maximo Work Orders',
  },
})

function MaximoRouteComponent() {
  const { siteID } = Route.useParams()
  if (!siteID) {
    return <Outlet />
  }

  return <MaximoWorkOrders siteID={siteID} />
}
